import { useEffect } from "react";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { Navigate, useNavigate } from "react-router-dom";

const PrivateRoute = ({ children }: { children: JSX.Element }) => {
  const navigate = useNavigate();

  const refreshTokenMutation = useMutation({
    mutationFn: (refreshToken: string) =>
      axios.post("https://goldshop.dibsolutions.com.au/api/token/refresh/", {
        refresh: refreshToken,
      }),
  });

  useEffect(() => {
    const interval = setInterval(async () => {
      const token = localStorage.getItem("token");
      const refreshToken = localStorage.getItem("refreshToken");
      if (!token || !refreshToken) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        const response = await refreshTokenMutation.mutateAsync(refreshToken);
        localStorage.setItem("token", response.data.access);
        localStorage.setItem("refreshToken", response.data.refresh);
      } catch {
        navigate("/login", { replace: true });
      }
    }, 280000);

    return () => {
      clearInterval(interval);
    };
  }, [navigate, refreshTokenMutation]);

  return children;
};

export default PrivateRoute;
